import React from 'react';
import { ReduxState } from 'interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { Card } from 'utilities/components';
import { Input } from '30pay/components';

const ProfileInfo: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    return (
        <Card title="اطلاعات هویتی" className={'flex-1'}>
            <div className="flex flex-col gap-4 w-full">
                <div className="flex items-center gap-6">
                    <Input value={props.user?.fullName ?? 'ثبت نشده'} disabled label="نام و نام خانوادگی:" />
                    <Input value={props.user?.fatherName ?? 'ثبت نشده'} disabled label="نام پدر" />
                </div>
                <div className="flex items-center gap-6">
                    <Input value={props.user?.nationalCode ?? 'ثبت نشده'} disabled label="کد ملی:" />
                    <Input
                        value={
                            props.user?.dateOfBirth && props.user.dateOfBirth !== ''
                                ? new Date(props.user.dateOfBirth).toLocaleDateString('fa')
                                : 'ثبت نشده'
                        }
                        disabled
                        label="تاریخ تولد:"
                    />
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(ProfileInfo);
